import React, { useEffect, useState, useCallback, useMemo } from 'react';
import API from '../api';
import { toast } from 'react-toastify';
import '../styles/global.css';

// ==========================================
// MODALS (Defined OUTSIDE to prevent re-renders)
// ==========================================

const MedicineDetailModal = ({ medicine, onClose, isMobile, fmt }) => {
  if (!medicine) return null;
  const isLowStock = medicine.quantity < (medicine.minStockLevel || 10);
  const profitMargin = medicine.purchasePricePerUnit
    ? ((medicine.sellingPricePerUnit - medicine.purchasePricePerUnit) / medicine.purchasePricePerUnit * 100).toFixed(1)
    : null;

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0, 0, 0, 0.5)', backdropFilter: 'blur(4px)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999, padding: isMobile ? 12 : 20 }} onClick={onClose}>
      <div style={{ background: '#ffffff', borderRadius: isMobile ? 12 : 16, width: isMobile ? '100%' : 'min(600px, 95%)', maxHeight: '90vh', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 40px rgba(0,0,0,0.2)', overflow: 'hidden' }} onClick={(e) => e.stopPropagation()}>
        <div style={{ padding: isMobile ? 16 : 24, overflowY: 'auto', flex: 1 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', borderBottom: '1px solid #e0f2fe', paddingBottom: 16, marginBottom: 20 }}>
            <div>
              <h2 style={{ margin: '0 0 4px 0', fontSize: 20, fontWeight: 700, color: '#1a202c' }}>{medicine.name}</h2>
              <p style={{ margin: 0, color: '#718096', fontSize: 13 }}>
                {medicine.brand && <span>{medicine.brand}</span>}
                {medicine.strength && <span> • {medicine.strength}</span>}
                <span> • {medicine.category}</span>
              </p>
            </div>
            <button onClick={onClose} style={{ background: '#f1f5f9', border: 'none', color: '#64748b', width: 32, height: 32, borderRadius: '50%', fontSize: 20, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', touchAction: 'manipulation' }}>×</button>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 12, marginBottom: 20 }}>
            <div style={{ background: '#f8fafc', borderRadius: 8, padding: 12, border: '1px solid #e2e8f0' }}>
              <span style={{ fontSize: 10, color: '#718096', textTransform: 'uppercase', fontWeight: 600 }}>Current Stock</span>
              <p style={{ fontSize: 16, fontWeight: 700, margin: '4px 0 0', color: isLowStock ? '#dc2626' : '#1a202c' }}>{medicine.quantity} {medicine.quantityUnit || 'units'}</p>
            </div>
            <div style={{ background: '#f8fafc', borderRadius: 8, padding: 12, border: '1px solid #e2e8f0' }}>
              <span style={{ fontSize: 10, color: '#718096', textTransform: 'uppercase', fontWeight: 600 }}>Rack Location</span>
              <p style={{ fontSize: 16, fontWeight: 700, margin: '4px 0 0', color: '#1a202c' }}>{medicine.rackNumber || 'N/A'}</p>
            </div>
          </div>

          <div style={{ background: '#f8fafc', borderRadius: 8, padding: 16, border: '1px solid #e2e8f0', marginBottom: 20 }}>
            <h3 style={{ fontSize: 13, fontWeight: 600, color: '#1a202c', margin: '0 0 12px' }}>Pricing & Profit</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12 }}>
              <div>
                <label style={{ fontSize: 10, color: '#718096', textTransform: 'uppercase' }}>MRP</label>
                <p style={{ fontSize: 14, fontWeight: 600, color: '#1a202c', margin: '2px 0 0' }}>Rs {fmt(medicine.mrpPerUnit || 0)}</p>
              </div>
              <div>
                <label style={{ fontSize: 10, color: '#718096', textTransform: 'uppercase' }}>Purchase Price</label>
                <p style={{ fontSize: 14, fontWeight: 600, color: '#1a202c', margin: '2px 0 0' }}>Rs {fmt(medicine.purchasePricePerUnit || 0)}</p>
              </div>
              <div>
                <label style={{ fontSize: 10, color: '#718096', textTransform: 'uppercase' }}>Selling Price</label>
                <p style={{ fontSize: 14, fontWeight: 600, color: '#22c55e', margin: '2px 0 0' }}>Rs {fmt(medicine.sellingPricePerUnit || 0)}</p>
              </div>
            </div>
            {profitMargin && (
              <div style={{ marginTop: 12, fontSize: 12, color: '#22c55e', fontWeight: 600 }}>
                Estimated Margin: {profitMargin}%
              </div>
            )}
          </div>
        </div>
        <div style={{ padding: isMobile ? 12 : 16, borderTop: '1px solid #e0f2fe', background: '#fafbfc' }}>
          <button onClick={onClose} style={{ padding: '10px 20px', background: '#ffffff', color: '#4a5568', border: '1px solid #e0f2fe', borderRadius: 6, fontWeight: 600, width: '100%', cursor: 'pointer' }}>Close Details</button>
        </div>
      </div>
    </div>
  );
};

const PurchaseDetailsModal = ({ purchase, onClose, isMobile, fmt }) => {
  if (!purchase) return null;

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0, 0, 0, 0.5)', backdropFilter: 'blur(4px)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999, padding: isMobile ? 12 : 20 }} onClick={onClose}>
      <div style={{ background: '#ffffff', borderRadius: isMobile ? 12 : 16, width: isMobile ? '100%' : 'min(800px, 95%)', maxHeight: '90vh', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 40px rgba(0,0,0,0.2)', overflow: 'hidden' }} onClick={(e) => e.stopPropagation()}>
        <div style={{ padding: isMobile ? 16 : 24, overflowY: 'auto', flex: 1 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', borderBottom: '1px solid #e0f2fe', paddingBottom: 16, marginBottom: 20 }}>
            <div>
              <h2 style={{ margin: '0 0 4px 0', fontSize: 20, fontWeight: 700, color: '#1a202c' }}>Invoice Details: {purchase.invoiceNumber}</h2>
              <p style={{ margin: 0, color: '#718096', fontSize: 13 }}>
                Procured on {new Date(purchase.purchaseDate).toLocaleDateString('en-IN')} from <strong>{purchase.partyName}</strong>
              </p>
            </div>
            <button onClick={onClose} style={{ background: '#f1f5f9', border: 'none', color: '#64748b', width: 32, height: 32, borderRadius: '50%', fontSize: 20, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>×</button>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)', gap: 12, marginBottom: 20 }}>
            <div style={{ background: '#f8fafc', borderRadius: 8, padding: 12, border: '1px solid #e2e8f0' }}>
              <span style={{ fontSize: 10, color: '#718096', textTransform: 'uppercase', fontWeight: 600 }}>Grand Total</span>
              <p style={{ fontSize: 16, fontWeight: 700, margin: '4px 0 0', color: '#1880c2' }}>Rs {fmt(purchase.totalAmount)}</p>
            </div>
            <div style={{ background: '#f8fafc', borderRadius: 8, padding: 12, border: '1px solid #e2e8f0' }}>
              <span style={{ fontSize: 10, color: '#718096', textTransform: 'uppercase', fontWeight: 600 }}>VAT/Tax Paid</span>
              <p style={{ fontSize: 16, fontWeight: 700, margin: '4px 0 0', color: purchase.tax > 0 ? '#1880c2' : '#718096' }}>Rs {fmt(purchase.tax || 0)}</p>
            </div>
            <div style={{ background: '#f8fafc', borderRadius: 8, padding: 12, border: '1px solid #e2e8f0' }}>
              <span style={{ fontSize: 10, color: '#718096', textTransform: 'uppercase', fontWeight: 600 }}>Due Amount</span>
              <p style={{ fontSize: 16, fontWeight: 700, margin: '4px 0 0', color: purchase.dueAmount > 0 ? '#dc2626' : '#22c55e' }}>Rs {fmt(purchase.dueAmount)}</p>
            </div>
            <div style={{ background: '#f8fafc', borderRadius: 8, padding: 12, border: '1px solid #e2e8f0' }}>
              <span style={{ fontSize: 10, color: '#718096', textTransform: 'uppercase', fontWeight: 600 }}>Payment Mode</span>
              <p style={{ fontSize: 16, fontWeight: 700, margin: '4px 0 0', color: '#1a202c' }}>{purchase.paymentType}</p>
            </div>
          </div>

          <div style={{ background: '#ffffff', borderRadius: 8, border: '1px solid #e0f2fe', padding: 16, marginBottom: 20 }}>
            <h3 style={{ fontSize: 14, fontWeight: 600, color: '#1a202c', margin: '0 0 12px' }}>Items Procured</h3>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr style={{ borderBottom: '2px solid #e0f2fe', textAlign: 'left' }}>
                    <th style={{ padding: '8px 12px', fontWeight: 600, color: '#4a5568' }}>Medicine Name</th>
                    <th style={{ padding: '8px 12px', fontWeight: 600, color: '#4a5568' }}>Batch #</th>
                    <th style={{ padding: '8px 12px', fontWeight: 600, color: '#4a5568' }}>Expiry</th>
                    <th style={{ padding: '8px 12px', fontWeight: 600, color: '#4a5568', textAlign: 'right' }}>Qty</th>
                    <th style={{ padding: '8px 12px', fontWeight: 600, color: '#4a5568', textAlign: 'right' }}>Cost Price</th>
                    <th style={{ padding: '8px 12px', fontWeight: 600, color: '#4a5568', textAlign: 'right' }}>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {purchase.items?.map((item, idx) => (
                    <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                      <td style={{ padding: '10px 12px', fontWeight: 600, color: '#1a202c' }}>{item.name}</td>
                      <td style={{ padding: '10px 12px', color: '#4a5568' }}>{item.batchNumber}</td>
                      <td style={{ padding: '10px 12px', color: '#1a202c' }}>
                        {item.expiryDate ? new Date(item.expiryDate).toLocaleDateString('en-IN') : 'N/A'}
                      </td>
                      <td style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 600 }}>{item.quantity}</td>
                      <td style={{ padding: '10px 12px', textAlign: 'right' }}>Rs {fmt(item.purchasePrice)}</td>
                      <td style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 700, color: '#1a202c' }}>Rs {fmt(item.total || item.quantity * item.purchasePrice)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div style={{ padding: isMobile ? 12 : 16, borderTop: '1px solid #e0f2fe', background: '#fafbfc' }}>
          <button onClick={onClose} style={{ padding: '10px 20px', background: '#ffffff', color: '#4a5568', border: '1px solid #e0f2fe', borderRadius: 6, fontWeight: 600, width: '100%', cursor: 'pointer' }}>Close Invoice</button>
        </div>
      </div>
    </div>
  );
};

// ==========================================
// MAIN COMPONENT
// ==========================================

export default function PurchasesPage() {
  // 1. Check for cached data for instant load
  const cachedPurchases = sessionStorage.getItem('purchasesList');
  const cachedParties = sessionStorage.getItem('partiesList');
  const cachedMedicines = sessionStorage.getItem('medicinesList');

  const [purchases, setPurchases] = useState(cachedPurchases ? JSON.parse(cachedPurchases) : []);
  const [parties, setParties] = useState(cachedParties ? JSON.parse(cachedParties) : []);
  const [medicines, setMedicines] = useState(cachedMedicines ? JSON.parse(cachedMedicines) : []);

  // Form State
  const [supplier, setSupplier] = useState('');
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [purchaseDate, setPurchaseDate] = useState(new Date().toISOString().split('T')[0]);
  const [paymentType, setPaymentType] = useState('CREDIT');
  const [paidAmount, setPaidAmount] = useState('');
  const [discount, setDiscount] = useState('');
  const [taxPercent, setTaxPercent] = useState('0'); 
  const [notes, setNotes] = useState('');

  const [purchaseItems, setPurchaseItems] = useState([]);
  const [searchMedQuery, setSearchMedQuery] = useState('');
  const [loading, setLoading] = useState(false); // Used for saving invoice
  const [selectedMedDetails, setSelectedMedDetails] = useState(null);
  const [showMedDetailsModal, setShowMedDetailsModal] = useState(false);
  const [selectedPurchase, setSelectedPurchase] = useState(null);
  const [showPurchaseDetailsModal, setShowPurchaseDetailsModal] = useState(false);

  const [showQuickAddMedModal, setShowQuickAddMedModal] = useState(false);
  const [quickMedForm, setQuickMedForm] = useState({
    name: '', brand: '', category: 'Tablet',
    sellingPricePerUnit: '', purchasePricePerUnit: '', mrpPerUnit: '', rackNumber: ''
  });

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isTablet, setIsTablet] = useState(window.innerWidth > 768 && window.innerWidth <= 1024);
  const [isSmallMobile, setIsSmallMobile] = useState(window.innerWidth <= 480);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 768);
      setIsTablet(width > 768 && width <= 1024);
      setIsSmallMobile(width <= 480);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const fetchData = useCallback(async () => {
    try {
      const [purchRes, partyRes, medRes] = await Promise.all([
        API.get('/purchases'), API.get('/parties'), API.get('/medicines')
      ]);
      
      const newPurchases = purchRes.data || [];
      const newParties = partyRes.data || [];
      const newMedicines = medRes.data || [];

      setPurchases(newPurchases);
      setParties(newParties);
      setMedicines(newMedicines);

      // 2. Cache them
      sessionStorage.setItem('purchasesList', JSON.stringify(newPurchases));
      sessionStorage.setItem('partiesList', JSON.stringify(newParties));
      sessionStorage.setItem('medicinesList', JSON.stringify(newMedicines));

    } catch (err) {
      console.error(err);
      toast.error('Failed to load purchases data');
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const selectedSupplierObj = useMemo(() => {
    return parties.find(p => p._id === supplier) || null;
  }, [supplier, parties]);

  const isVatAllowed = selectedSupplierObj?.registrationType === 'VAT Registered';

  useEffect(() => {
    if (selectedSupplierObj) {
      if (isVatAllowed) {
        setTaxPercent('13'); 
      } else {
        setTaxPercent('0');  
      }
    }
  }, [selectedSupplierObj, isVatAllowed]);

  const openQuickAddMedModal = (initialName = '') => {
    setQuickMedForm({
      name: initialName, brand: '', category: 'Tablet',
      sellingPricePerUnit: '', purchasePricePerUnit: '', mrpPerUnit: '', rackNumber: ''
    });
    setShowQuickAddMedModal(true);
  };

  const handleQuickAddMedicineSubmit = async (e) => {
    e.preventDefault();
    if (!quickMedForm.name.trim()) return toast.error('Medicine name is required');
    try {
      const res = await API.post('/medicines', {
        ...quickMedForm,
        sellingPricePerUnit: Number(quickMedForm.sellingPricePerUnit || 0),
        purchasePricePerUnit: Number(quickMedForm.purchasePricePerUnit || 0),
        mrpPerUnit: Number(quickMedForm.mrpPerUnit || 0),
        party: supplier || undefined,
        quantity: 0
      });
      const newMed = res.data;
      toast.success(`Registered "${newMed.name}" in inventory!`);
      setShowQuickAddMedModal(false);

      const medRes = await API.get('/medicines');
      const newMedicines = medRes.data || [];
      setMedicines(newMedicines);
      sessionStorage.setItem('medicinesList', JSON.stringify(newMedicines)); // Update cache
      
      addMedicineToInvoice(newMed);
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || 'Failed to add medicine');
    }
  };

  const addMedicineToInvoice = (med) => {
    if (purchaseItems.some(i => i.medicine === med._id)) {
      toast.warning('Medicine already added');
      return;
    }
    setPurchaseItems([...purchaseItems, {
      medicine: med._id, name: med.name, batchNumber: '', expiryDate: '',
      quantity: 1, purchasePrice: med.purchasePricePerUnit || 0,
      mrp: med.mrpPerUnit || 0, sellingPrice: med.sellingPricePerUnit || 0
    }]);
    setSearchMedQuery('');
  };

  // ✅ SIMPLIFIED UPDATE LOGIC: No debouncing needed for direct DOM inputs
  const updateItemField = (index, field, val) => {
    setPurchaseItems(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: val };
      return updated;
    });
  };

  const removeItem = (index) => {
    setPurchaseItems(prevItems => prevItems.filter((_, i) => i !== index));
  };

  // Calculations
  const subtotal = purchaseItems.reduce((acc, item) => acc + (Number(item.quantity || 0) * Number(item.purchasePrice || 0)), 0);
  const discountVal = Number(discount || 0);
  const taxVal = Math.round((subtotal - discountVal) * (Number(taxPercent || 0) / 100) * 100) / 100;
  const totalAmount = Math.max(0, subtotal - discountVal + taxVal);
  const dueAmount = Math.max(0, totalAmount - Number(paidAmount || 0));

  const resetForm = () => {
    setSupplier('');
    setInvoiceNumber('');
    setPurchaseDate(new Date().toISOString().split('T')[0]);
    setPaymentType('CREDIT');
    setPaidAmount('');
    setDiscount('');
    setTaxPercent('0');
    setPurchaseItems([]);
    setNotes('');
  };

  const handleSavePurchase = async (e) => {
    e.preventDefault();
    if (!supplier) return toast.error('Please select a supplier');
    if (!invoiceNumber.trim()) return toast.error('Invoice Number is required');
    if (purchaseItems.length === 0) return toast.error('Please add at least one medicine');

    for (let item of purchaseItems) {
      if (!item.batchNumber.trim()) return toast.error(`Batch number is missing for ${item.name}`);
      if (!item.expiryDate) return toast.error(`Expiry date is missing for ${item.name}`);
      if (item.quantity <= 0) return toast.error(`Quantity must be greater than 0 for ${item.name}`);
      if (item.purchasePrice <= 0) return toast.error(`Purchase price must be greater than 0 for ${item.name}`);
    }

    setLoading(true);
    try {
      const payload = {
        party: supplier, partyName: selectedSupplierObj.name, invoiceNumber, purchaseDate,
        items: purchaseItems.map(item => ({ ...item, total: Number(item.quantity) * Number(item.purchasePrice) })),
        subtotal, discount: discountVal, tax: taxVal, totalAmount,
        paidAmount: Number(paidAmount || 0), dueAmount, paymentType, notes
      };
      await API.post('/purchases', payload);
      toast.success('Purchase recorded successfully');
      resetForm();
      fetchData();
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || 'Error recording purchase invoice');
    } finally {
      setLoading(false);
    }
  };

  const handleDeletePurchase = async (id) => {
    if (!window.confirm('Are you sure you want to delete this purchase invoice? This will deduct the stock levels!')) return;
    try {
      await API.delete(`/purchases/${id}`);
      toast.success('Purchase invoice deleted');
      fetchData();
    } catch (err) {
      console.error(err);
      toast.error('Failed to delete purchase invoice');
    }
  };

  const fmt = (num) => Number.isFinite(Number(num)) ? Number(num).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00';

  const filteredMedicines = searchMedQuery
    ? medicines.filter(m => m.name.toLowerCase().includes(searchMedQuery.toLowerCase())).slice(0, 5)
    : [];

  // ==========================================
  // STYLES
  // ==========================================
  const styles = {
    container: { minHeight: '100vh', background: '#f4f9fd', fontFamily: "'Inter', sans-serif" },
    header: { background: '#ffffff', borderBottom: '1px solid #e0f2fe', padding: isMobile ? '12px 16px' : isTablet ? '16px 24px' : '20px 32px', display: 'flex', flexDirection: isMobile ? 'column' : 'row', justifyContent: 'space-between', alignItems: isMobile ? 'flex-start' : 'center', gap: isMobile ? 12 : 0, position: 'sticky', top: 0, zIndex: 100, boxShadow: '0 1px 3px rgba(0, 0, 0, 0.02)' },
    headerTitle: { display: 'flex', alignItems: 'center', gap: isMobile ? 8 : 12 },
    headerIcon: { width: isMobile ? 32 : 40, height: isMobile ? 32 : 40, background: '#1880c2', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: isMobile ? 10 : 12, fontWeight: 700, letterSpacing: '0.5px' },
    headerText: { fontSize: isMobile ? 16 : 20, fontWeight: 700, color: '#1a202c', letterSpacing: '-0.3px' },
    headerSubtext: { fontSize: isMobile ? 11 : 12, color: '#718096', fontWeight: 500, marginTop: 2, display: isSmallMobile ? 'none' : 'block' },
    main: { maxWidth: 1400, margin: '0 auto', padding: isMobile ? '12px' : '24px 32px' },
    grid: { display: 'grid', gridTemplateColumns: isMobile ? '1fr' : isTablet ? '1fr' : '2.2fr 1fr', gap: isMobile ? 16 : 24, alignItems: 'start' },
    card: { background: '#ffffff', borderRadius: isMobile ? 8 : 10, border: '1px solid #e0f2fe', marginBottom: isMobile ? 16 : 24, boxShadow: '0 1px 2px rgba(24, 128, 194, 0.05)' },
    cardHeader: { padding: isMobile ? '12px 16px' : '16px 24px', borderBottom: '1px solid #e0f2fe', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f8fafc' },
    cardTitle: { fontSize: isMobile ? 14 : 16, fontWeight: 700, color: '#1a202c', display: 'flex', alignItems: 'center', gap: 10, margin: 0 },
    cardBody: { padding: isMobile ? 16 : 24 },
    formGroup: { display: 'flex', flexDirection: 'column', gap: 6 },
    label: { fontSize: isMobile ? 10 : 11, fontWeight: 600, color: '#4a5568', textTransform: 'uppercase', letterSpacing: '0.5px' },
    input: { padding: isMobile ? '12px 14px' : '10px 14px', borderRadius: 6, border: '1px solid #e1e8ed', fontSize: isMobile ? 16 : 14, width: '100%', boxSizing: 'border-box', background: '#fff', transition: 'border-color 0.2s', outline: 'none', touchAction: 'manipulation', WebkitTapHighlightColor: 'transparent' },
    select: { padding: isMobile ? '12px 14px' : '10px 14px', borderRadius: 6, border: '1px solid #e1e8ed', fontSize: isMobile ? 16 : 14, width: '100%', boxSizing: 'border-box', background: '#fff', cursor: 'pointer', outline: 'none' },
    btnPrimary: { padding: isMobile ? '12px 16px' : '12px 24px', background: '#1880c2', color: 'white', border: 'none', borderRadius: 6, fontWeight: 600, cursor: 'pointer', fontSize: isMobile ? 16 : 14, transition: 'all 0.2s', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, width: '100%' },
    btnSecondary: { padding: isMobile ? '8px 16px' : '10px 20px', background: '#ffffff', color: '#4a5568', border: '1px solid #e0f2fe', borderRadius: 6, fontWeight: 600, cursor: 'pointer', fontSize: isMobile ? 14 : 14, transition: 'all 0.2s', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flex: isSmallMobile ? 1 : 'none' },
    btnDanger: { padding: isMobile ? '8px 12px' : '6px 12px', background: '#fef5f5', color: '#991b1b', border: '1px solid #fecaca', borderRadius: 6, fontWeight: 600, cursor: 'pointer', fontSize: isMobile ? 12 : 12, transition: 'all 0.2s' },
    table: { width: '100%', borderCollapse: 'collapse' },
    th: { padding: isMobile ? '8px 10px' : '12px 16px', textAlign: 'left', fontSize: isMobile ? 10 : 11, fontWeight: 600, color: '#718096', background: '#f4f9fd', borderBottom: '1px solid #e0f2fe', textTransform: 'uppercase', letterSpacing: '0.5px', whiteSpace: 'nowrap' },
    td: { padding: isMobile ? '10px' : '12px 16px', fontSize: isMobile ? 12 : 14, color: '#1a202c', borderBottom: '1px solid #f7fafc', verticalAlign: 'middle' },
    rowInputs: { border: '1px solid #e1e8ed', padding: '8px 10px', borderRadius: 6, width: '100%', minWidth: '85px', boxSizing: 'border-box', outline: 'none', fontSize: isMobile ? 16 : 13, background: '#fff', transition: 'border-color 0.2s', touchAction: 'manipulation' },
    mobileCard: { background: '#fff', borderRadius: 10, border: '1px solid #e0f2fe', padding: 16, marginBottom: 12, transition: 'all 0.2s' },
    emptyState: { textAlign: 'center', padding: isMobile ? 30 : 60, color: '#718096' },
    badge: { padding: '4px 10px', borderRadius: 4, fontSize: 11, fontWeight: 600, display: 'inline-block', letterSpacing: '0.3px' },
    searchDropdown: { position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: '1px solid #e0f2fe', borderRadius: 8, zIndex: 10, boxShadow: '0 4px 12px rgba(24, 128, 194, 0.1)', maxHeight: 200, overflowY: 'auto' },
    searchItem: { padding: isMobile ? '12px 16px' : '10px 16px', borderBottom: '1px solid #f4f9fd', cursor: 'pointer', transition: 'background 0.2s', fontSize: isMobile ? 14 : 14 }
  };

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <div style={styles.headerTitle}>
          <div style={styles.headerIcon}>PUR</div>
          <div>
            <div style={styles.headerText}>Purchase Procurement</div>
            <div style={styles.headerSubtext}>Receive goods and log supplier invoices</div>
          </div>
        </div>
      </header>

      <main style={styles.main}>
        <div style={styles.grid}>
          {/* LEFT COLUMN */}
          <div style={{ minWidth: 0 }}>
            <div style={styles.card}>
              <div style={styles.cardHeader}>
                <div style={styles.cardTitle}>Goods Receipt Items</div>
              </div>
              <div style={styles.cardBody}>
                <div style={{ marginBottom: 20 }}>
                  <label style={styles.label}>Search & Add Medicine</label>
                  <div style={{ display: 'flex', gap: 10, alignItems: isSmallMobile ? 'stretch' : 'center', flexDirection: isSmallMobile ? 'column' : 'row' }}>
                    <div style={{ flex: 1, position: 'relative' }}>
                      <input
                        value={searchMedQuery}
                        onChange={e => setSearchMedQuery(e.target.value)}
                        placeholder="Type medicine name to add to procurement invoice..."
                        style={styles.input}
                        onFocus={(e) => e.target.style.borderColor = '#1880c2'} 
                        onBlur={(e) => setTimeout(() => e.target.style.borderColor = '#e1e8ed', 150)} // Delay blur for click
                        autoComplete="off"
                        spellCheck="false"
                      />
                      {searchMedQuery && (
                        <div style={styles.searchDropdown}>
                          {filteredMedicines.map(med => (
                            <div
                              key={med._id}
                              onClick={() => addMedicineToInvoice(med)}
                              onMouseDown={(e) => e.preventDefault()} // Keep focus on input
                              style={styles.searchItem}
                              onMouseEnter={(e) => e.currentTarget.style.background = '#f4f9fd'}
                              onMouseLeave={(e) => e.currentTarget.style.background = '#fff'}
                            >
                              <strong style={{ color: '#1a202c' }}>{med.name}</strong>
                              <span style={{ color: '#718096', fontSize: isMobile ? 12 : 13 }}> - Brand: {med.brand || 'N/A'} (Stock: {med.quantity})</span>
                            </div>
                          ))}
                          <div onMouseDown={(e) => e.preventDefault()} onClick={() => openQuickAddMedModal(searchMedQuery)} style={{ padding: isMobile ? '12px 16px' : '10px 14px', background: '#e0f2fe', color: '#1880c2', fontWeight: 600, fontSize: isMobile ? 13 : 13, cursor: 'pointer', borderTop: '1px solid #bae6fd', display: 'flex', alignItems: 'center', gap: 6 }}>
                            <span>➕</span> Register "{searchMedQuery}" as New Medicine
                          </div>
                        </div>
                      )}
                    </div>
                    <button type="button" onClick={() => openQuickAddMedModal(searchMedQuery)} style={{ padding: isMobile ? '12px 16px' : '10px 14px', background: '#e0f2fe', color: '#1880c2', border: '1px solid #bae6fd', borderRadius: 6, fontWeight: 600, fontSize: isMobile ? 13 : 13, cursor: 'pointer', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                      ➕ New Med
                    </button>
                  </div>
                </div>

                {/* ✅ FIX: RAW DOM ELEMENTS FOR INPUTS (GUARANTEES NO FOCUS LOSS) */}
                {isMobile ? (
                  <div>
                    {purchaseItems.length === 0 ? (
                      <div style={styles.emptyState}>
                        <div style={{ fontSize: 48, marginBottom: 16, opacity: 0.3 }}>📋</div>
                        <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>No items added</div>
                        <div style={{ fontSize: 14 }}>Search and add medicines above</div>
                      </div>
                    ) : (
                      purchaseItems.map((item, index) => (
                        <div key={item.medicine} style={styles.mobileCard}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
                            <div style={{ flex: 1 }}>
                              <div 
                                style={{ fontSize: 14, fontWeight: 600, color: '#1880c2', textDecoration: 'underline', cursor: 'pointer', marginBottom: 4 }}
                                onClick={() => {
                                  const med = medicines.find(m => m._id === item.medicine);
                                  if (med) { setSelectedMedDetails(med); setShowMedDetailsModal(true); }
                                }}
                              >
                                {item.name}
                              </div>
                              <div style={{ fontSize: 12, color: '#718096' }}>
                                Total: Rs {fmt(item.quantity * item.purchasePrice)}
                              </div>
                            </div>
                            <button onClick={() => removeItem(index)} style={styles.btnDanger}>Remove</button>
                          </div>

                          <div style={{ display: 'grid', gridTemplateColumns: isSmallMobile ? '1fr' : 'repeat(2, 1fr)', gap: 12 }}>
                            <div style={styles.formGroup}>
                              <label style={styles.label}>Batch Number</label>
                              <input 
                                value={item.batchNumber} 
                                onChange={(e) => updateItemField(index, 'batchNumber', e.target.value)}
                                onFocus={(e) => e.target.style.borderColor = '#1880c2'}
                                onBlur={(e) => e.target.style.borderColor = '#e1e8ed'}
                                style={styles.input}
                              />
                            </div>
                            <div style={styles.formGroup}>
                              <label style={styles.label}>Expiry Date</label>
                              <input 
                                type="date" 
                                value={item.expiryDate} 
                                onChange={(e) => updateItemField(index, 'expiryDate', e.target.value)}
                                onFocus={(e) => e.target.style.borderColor = '#1880c2'}
                                onBlur={(e) => e.target.style.borderColor = '#e1e8ed'}
                                style={styles.input}
                              />
                            </div>
                            <div style={styles.formGroup}>
                              <label style={styles.label}>Quantity</label>
                              <input 
                                type="number" 
                                inputMode="numeric"
                                min="1" 
                                value={item.quantity} 
                                onChange={(e) => updateItemField(index, 'quantity', parseInt(e.target.value) || 0)}
                                onFocus={(e) => e.target.style.borderColor = '#1880c2'}
                                onBlur={(e) => e.target.style.borderColor = '#e1e8ed'}
                                style={styles.input}
                              />
                            </div>
                            <div style={styles.formGroup}>
                              <label style={styles.label}>Cost (Unit)</label>
                              <input 
                                type="number" 
                                inputMode="decimal"
                                step="0.01" 
                                value={item.purchasePrice} 
                                onChange={(e) => updateItemField(index, 'purchasePrice', parseFloat(e.target.value) || 0)}
                                onFocus={(e) => e.target.style.borderColor = '#1880c2'}
                                onBlur={(e) => e.target.style.borderColor = '#e1e8ed'}
                                style={styles.input}
                              />
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                ) : (
                  <div style={{ overflowX: 'auto', paddingBottom: '8px' }}>
                    <table style={styles.table}>
                      <thead>
                        <tr>
                          <th style={{...styles.th, minWidth: '180px'}}>Medicine</th>
                          <th style={{...styles.th, minWidth: '110px'}}>Batch #</th>
                          <th style={{...styles.th, minWidth: '130px'}}>Expiry</th>
                          <th style={{...styles.th, minWidth: '85px'}}>Qty</th>
                          <th style={{...styles.th, minWidth: '100px'}}>Cost (Unit)</th>
                          <th style={{...styles.th, minWidth: '100px'}}>Selling</th>
                          <th style={{...styles.th, minWidth: '110px'}}>Total</th>
                          <th style={{...styles.th, width: '40px'}}></th>
                        </tr>
                      </thead>
                      <tbody>
                        {purchaseItems.map((item, index) => (
                          <tr key={item.medicine}>
                            <td style={{...styles.td, fontWeight: 600}}>
                              <span style={{ cursor: 'pointer', textDecoration: 'underline', color: '#1880c2' }} onClick={() => { const med = medicines.find(m => m._id === item.medicine); if (med) { setSelectedMedDetails(med); setShowMedDetailsModal(true); } else { toast.error('Medicine details not found'); } }}>
                                {item.name}
                              </span>
                            </td>
                            <td style={styles.td}>
                              <input 
                                value={item.batchNumber} 
                                onChange={e => updateItemField(index, 'batchNumber', e.target.value)} 
                                onFocus={(e) => e.target.style.borderColor = '#1880c2'}
                                onBlur={(e) => e.target.style.borderColor = '#e1e8ed'}
                                placeholder="Batch No" 
                                style={styles.rowInputs} 
                              />
                            </td>
                            <td style={styles.td}>
                              <input 
                                type="date" 
                                value={item.expiryDate} 
                                onChange={e => updateItemField(index, 'expiryDate', e.target.value)} 
                                onFocus={(e) => e.target.style.borderColor = '#1880c2'}
                                onBlur={(e) => e.target.style.borderColor = '#e1e8ed'}
                                style={styles.rowInputs} 
                              />
                            </td>
                            <td style={styles.td}>
                              <input 
                                type="number" 
                                inputMode="numeric" 
                                min="1" 
                                value={item.quantity} 
                                onChange={e => updateItemField(index, 'quantity', parseInt(e.target.value) || 0)} 
                                onFocus={(e) => e.target.style.borderColor = '#1880c2'}
                                onBlur={(e) => e.target.style.borderColor = '#e1e8ed'}
                                style={styles.rowInputs} 
                              />
                            </td>
                            <td style={styles.td}>
                              <input 
                                type="number" 
                                inputMode="decimal" 
                                step="0.01" 
                                value={item.purchasePrice} 
                                onChange={e => updateItemField(index, 'purchasePrice', parseFloat(e.target.value) || 0)} 
                                onFocus={(e) => e.target.style.borderColor = '#1880c2'}
                                onBlur={(e) => e.target.style.borderColor = '#e1e8ed'}
                                style={styles.rowInputs} 
                              />
                            </td>
                            <td style={styles.td}>
                              <input 
                                type="number" 
                                inputMode="decimal" 
                                step="0.01" 
                                value={item.sellingPrice} 
                                onChange={e => updateItemField(index, 'sellingPrice', parseFloat(e.target.value) || 0)} 
                                onFocus={(e) => e.target.style.borderColor = '#1880c2'}
                                onBlur={(e) => e.target.style.borderColor = '#e1e8ed'}
                                style={styles.rowInputs} 
                              />
                            </td>
                            <td style={{ ...styles.td, fontWeight: 700, color: '#1a202c', whiteSpace: 'nowrap' }}>Rs {fmt(item.quantity * item.purchasePrice)}</td>
                            <td style={styles.td}><button onClick={() => removeItem(index)} style={styles.btnDanger} title="Remove item">✕</button></td>
                          </tr>
                        ))}
                        {purchaseItems.length === 0 && (
                          <tr><td colSpan="8" style={{ ...styles.td, textAlign: 'center', padding: '40px 20px', color: '#94a3b8' }}>Procurement invoice is empty. Search and add medicines above.</td></tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>

            {/* Past Invoices */}
            <div style={styles.card}>
              <div style={styles.cardHeader}>
                <div style={styles.cardTitle}>Past Procurement Invoices</div>
              </div>
              <div style={styles.cardBody}>
                {isMobile ? (
                  <div>
                    {purchases.length === 0 ? (
                      <div style={styles.emptyState}><div style={{ fontSize: 48, marginBottom: 16, opacity: 0.3 }}>📄</div><div style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>No purchase records</div></div>
                    ) : (
                      purchases.map(purchase => (
                        <div key={purchase._id} style={styles.mobileCard}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
                            <div>
                              <div style={{ fontSize: 14, fontWeight: 600, color: '#1880c2', textDecoration: 'underline', cursor: 'pointer' }} onClick={() => { setSelectedPurchase(purchase); setShowPurchaseDetailsModal(true); }}>{purchase.invoiceNumber}</div>
                              <div style={{ fontSize: 12, color: '#718096', marginTop: 2 }}>{new Date(purchase.purchaseDate).toLocaleDateString('en-IN')}</div>
                            </div>
                            <div style={{ textAlign: 'right' }}>
                              <div style={{ fontSize: 16, fontWeight: 700, color: '#1a202c' }}>Rs {fmt(purchase.totalAmount)}</div>
                              <div style={{ fontSize: 12, color: purchase.dueAmount > 0 ? '#dc2626' : '#16a34a', fontWeight: 600 }}>Due: Rs {fmt(purchase.dueAmount)}</div>
                            </div>
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div>
                              <div style={{ fontSize: 12, color: '#718096' }}>Supplier</div>
                              <div style={{ fontSize: 13, fontWeight: 500, color: '#1a202c' }}>{purchase.partyName}</div>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                              <button onClick={() => { setSelectedPurchase(purchase); setShowPurchaseDetailsModal(true); }} style={{ ...styles.btnSecondary, padding: '4px 8px', fontSize: 11 }}>View</button>
                              <button onClick={() => handleDeletePurchase(purchase._id)} style={styles.btnDanger}>Delete</button>
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                ) : (
                  <div style={{ overflowX: 'auto' }}>
                    <table style={styles.table}>
                      <thead>
                        <tr>
                          <th style={{...styles.th, minWidth: '100px'}}>Date</th>
                          <th style={{...styles.th, minWidth: '120px'}}>Invoice #</th>
                          <th style={{...styles.th, minWidth: '150px'}}>Supplier</th>
                          <th style={{...styles.th, minWidth: '100px'}}>Payment</th>
                          <th style={{...styles.th, minWidth: '120px'}}>Total</th>
                          <th style={{...styles.th, minWidth: '120px'}}>Dues</th>
                          <th style={{...styles.th, width: '80px'}}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {purchases.map(p => (
                          <tr key={p._id}>
                            <td style={styles.td}>{new Date(p.purchaseDate).toLocaleDateString('en-IN')}</td>
                            <td style={{ ...styles.td, fontWeight: 600 }}><span style={{ cursor: 'pointer', textDecoration: 'underline', color: '#1880c2' }} onClick={() => { setSelectedPurchase(p); setShowPurchaseDetailsModal(true); }}>{p.invoiceNumber}</span></td>
                            <td style={styles.td}>{p.partyName}</td>
                            <td style={styles.td}><span style={{ ...styles.badge, background: p.paymentType === 'CREDIT' ? '#fef5f1' : '#f0fdf4', color: p.paymentType === 'CREDIT' ? '#9a3412' : '#166534' }}>{p.paymentType}</span></td>
                            <td style={{...styles.td, fontWeight: 600}}>Rs {fmt(p.totalAmount)}</td>
                            <td style={{ ...styles.td, color: p.dueAmount > 0 ? '#dc2626' : '#16a34a', fontWeight: 700 }}>Rs {fmt(p.dueAmount)}</td>
                            <td style={styles.td}>
                              <button onClick={() => { setSelectedPurchase(p); setShowPurchaseDetailsModal(true); }} style={{ ...styles.btnSecondary, marginRight: 8, padding: '6px 12px', fontSize: 12 }}>View</button>
                              <button onClick={() => handleDeletePurchase(p._id)} style={styles.btnDanger} onMouseEnter={(e) => e.currentTarget.style.background = '#fee2e2'} onMouseLeave={(e) => e.currentTarget.style.background = '#fef5f5'}>Delete</button>
                            </td>
                          </tr>
                        ))}
                        {purchases.length === 0 && <tr><td colSpan="7" style={{ ...styles.td, textAlign: 'center', padding: '24px', color: '#94a3b8' }}>No past purchase records found.</td></tr>}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* RIGHT COLUMN */}
          <div>
            <form onSubmit={handleSavePurchase} style={styles.card}>
              <div style={styles.cardHeader}>
                <div style={styles.cardTitle}>Invoice Summary</div>
              </div>
              <div style={styles.cardBody}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                  
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Supplier / Vendor *</label>
                    <select
                      value={supplier}
                      onChange={e => setSupplier(e.target.value)}
                      style={{...styles.select, borderColor: '#1880c2', borderWidth: 2}}
                      required
                    >
                      <option value="">-- Select Supplier --</option>
                      {parties.map(p => (
                        <option key={p._id} value={p._id}>
                          {p.name} - ({p.registrationType === 'VAT Registered' ? 'VAT' : p.registrationType === 'PAN Registered' ? 'PAN' : 'Unreg.'})
                        </option>
                      ))}
                    </select>
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 16 }}>
                    <div style={styles.formGroup}><label style={styles.label}>Invoice Number</label><input value={invoiceNumber} onChange={e => setInvoiceNumber(e.target.value)} placeholder="SUPP-1234" style={styles.input} required /></div>
                    <div style={styles.formGroup}><label style={styles.label}>Date</label><input type="date" value={purchaseDate} onChange={e => setPurchaseDate(e.target.value)} style={styles.input} required /></div>
                  </div>

                  <hr style={{ border: 0, borderTop: '1px solid #e0f2fe', margin: '8px 0' }} />

                  <div style={{ display: 'flex', flexDirection: 'column', gap: 10, fontSize: 14 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ color: '#64748b', fontSize: isMobile ? 14 : 14 }}>Subtotal:</span>
                      <span style={{ fontWeight: 600, fontSize: isMobile ? 14 : 14 }}>Rs {fmt(subtotal)}</span>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexDirection: isSmallMobile ? 'column' : 'row', gap: isSmallMobile ? 4 : 0 }}>
                      <span style={{ color: '#64748b', fontSize: isMobile ? 14 : 14 }}>Discount:</span>
                      <input type="number" inputMode="decimal" placeholder="Discount (Rs)" value={discount} onChange={e => setDiscount(e.target.value)} style={{ ...styles.input, width: isSmallMobile ? '100%' : 120, padding: '8px 12px', fontSize: 14, textAlign: isSmallMobile ? 'left' : 'right' }} />
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexDirection: isSmallMobile ? 'column' : 'row', gap: isSmallMobile ? 4 : 0 }}>
                      <span style={{ color: '#64748b', fontSize: isMobile ? 14 : 14 }}>VAT/GST:</span>
                      <div style={{ width: isSmallMobile ? '100%' : 120 }}>
                        <select
                          value={taxPercent}
                          onChange={e => setTaxPercent(e.target.value)}
                          disabled={!isVatAllowed} 
                          style={{
                            ...styles.select,
                            width: '100%',
                            padding: '8px 12px',
                            fontSize: 14,
                            background: isVatAllowed ? '#fff' : '#f1f5f9',
                            cursor: isVatAllowed ? 'pointer' : 'not-allowed'
                          }}
                        >
                          <option value="0">0% (Exempt)</option>
                          <option value="5">5% GST</option>
                          <option value="10">10% VAT</option>
                          <option value="13">13% VAT</option>
                          <option value="18">18% GST</option>
                        </select>
                      </div>
                    </div>
                    
                    {!isVatAllowed && supplier && (
                      <div style={{ fontSize: 12, color: '#dc2626', textAlign: 'right', marginTop: -4 }}>
                        *VAT disabled for {selectedSupplierObj.registrationType} Supplier
                      </div>
                    )}

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ color: '#64748b', fontSize: isMobile ? 14 : 14 }}>Tax Amount:</span>
                      <span style={{ fontWeight: 600, fontSize: isMobile ? 14 : 14 }}>Rs {fmt(taxVal)}</span>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: isMobile ? 15 : 16, borderTop: '1px dashed #e0f2fe', paddingTop: 10, marginTop: 4 }}>
                      <strong style={{ color: '#1a202c' }}>Grand Total:</strong>
                      <strong style={{ color: '#1880c2', fontSize: 18 }}>Rs {fmt(totalAmount)}</strong>
                    </div>
                  </div>

                  <hr style={{ border: 0, borderTop: '1px solid #e0f2fe', margin: '8px 0' }} />

                  <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 16 }}>
                    <div style={styles.formGroup}><label style={styles.label}>Payment Mode</label>
                      <select value={paymentType} onChange={e => setPaymentType(e.target.value)} style={styles.select}>
                        <option value="CREDIT">On Credit</option>
                        <option value="CASH">Cash Payment</option>
                        <option value="ONLINE">Bank/Online</option>
                      </select>
                    </div>
                    <div style={styles.formGroup}><label style={styles.label}>Amount Paid</label>
                      <input type="number" inputMode="decimal" placeholder="Amount paid" value={paidAmount} onChange={e => setPaidAmount(e.target.value)} style={styles.input} disabled={paymentType === 'CREDIT'} />
                    </div>
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'space-between', background: '#f8fafc', padding: 12, borderRadius: 8, border: '1px solid #e0f2fe' }}>
                    <span style={{ color: '#dc2626', fontWeight: 600, fontSize: isMobile ? 13 : 13 }}>Outstanding Dues:</span>
                    <strong style={{ color: '#dc2626', fontSize: isMobile ? 15 : 16 }}>Rs {fmt(dueAmount)}</strong>
                  </div>

                  <div style={styles.formGroup}>
                    <label style={styles.label}>Purchase Notes</label>
                    <textarea value={notes} onChange={e => setNotes(e.target.value)} placeholder="Add supplier notes (invoice terms, delivery info)..." style={{ ...styles.input, height: 60, resize: 'none' }} />
                  </div>

                  <button
                    type="submit"
                    style={{ ...styles.btnPrimary, opacity: loading ? 0.7 : 1 }}
                    disabled={loading}
                    onMouseEnter={(e) => !loading && (e.currentTarget.style.background = '#0369a1')} 
                    onMouseLeave={(e) => !loading && (e.currentTarget.style.background = '#1880c2')}
                  >
                    {loading ? 'Saving Invoice...' : 'Save Procurement Invoice'}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </main>

      {/* QUICK ADD MEDICINE MODAL */}
      {showQuickAddMedModal && (
        <div style={styles.modal} onClick={() => setShowQuickAddMedModal(false)}>
          <div style={{ ...styles.modalContent, maxWidth: 580, borderRadius: 16 }} onClick={e => e.stopPropagation()}>
            <div style={{ padding: isMobile ? '16px' : '20px 24px', background: 'linear-gradient(135deg, #1880c2 0%, #0369a1 100%)', color: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <span style={{ fontSize: isMobile ? 9 : 10, background: 'rgba(255,255,255,0.2)', padding: '3px 10px', borderRadius: 12, fontWeight: 700, letterSpacing: '0.5px', textTransform: 'uppercase' }}>💊 Quick Inventory Registration</span>
                <h3 style={{ margin: '6px 0 0 0', fontSize: isMobile ? 16 : 18, fontWeight: 800, color: '#ffffff' }}>Register New Medicine</h3>
              </div>
              <button type="button" onClick={() => setShowQuickAddMedModal(false)} style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: '#fff', borderRadius: '50%', width: 32, height: 32, cursor: 'pointer', fontSize: 16, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✕</button>
            </div>

            <form onSubmit={handleQuickAddMedicineSubmit} style={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
              <div style={{ ...styles.modalBody, padding: isMobile ? 16 : 20 }}>
                <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 12, padding: isMobile ? 12 : 16, marginBottom: 16 }}>
                  <div style={{ fontSize: isMobile ? 11 : 12, fontWeight: 700, color: '#1880c2', textTransform: 'uppercase', marginBottom: 12, letterSpacing: '0.5px', display: 'flex', alignItems: 'center', gap: 6 }}><span>📋</span> Basic Medicine Info</div>
                  <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)', gap: 12 }}>
                    <div style={{ ...styles.formGroup, gridColumn: isMobile ? 'span 1' : 'span 2' }}><label style={styles.label}>Medicine Name *</label><input value={quickMedForm.name} onChange={e => setQuickMedForm({ ...quickMedForm, name: e.target.value })} placeholder="e.g. Amoxicillin 500mg Capsule" style={{ ...styles.input, borderColor: '#1880c2', fontWeight: 600 }} required autoFocus /></div>
                    <div style={styles.formGroup}><label style={styles.label}>Brand / Manufacturer</label><input value={quickMedForm.brand} onChange={e => setQuickMedForm({ ...quickMedForm, brand: e.target.value })} placeholder="e.g. Beximco / Square" style={styles.input} /></div>
                    <div style={styles.formGroup}><label style={styles.label}>Form / Category</label><select value={quickMedForm.category} onChange={e => setQuickMedForm({ ...quickMedForm, category: e.target.value })} style={styles.select}><option value="Tablet">💊 Tablet</option><option value="Capsule">💊 Capsule</option><option value="Syrup">🧪 Syrup</option><option value="Injection">💉 Injection</option><option value="Ointment">🧴 Ointment</option><option value="Drops">👁️ Drops</option><option value="Inhaler">🫁 Inhaler</option><option value="Other">📦 Other</option></select></div>
                  </div>
                </div>

                <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 12, padding: isMobile ? 12 : 16, marginBottom: 16 }}>
                  <div style={{ fontSize: isMobile ? 11 : 12, fontWeight: 700, color: '#166534', textTransform: 'uppercase', marginBottom: 12, letterSpacing: '0.5px', display: 'flex', alignItems: 'center', gap: 6 }}><span>🏷️</span> Pricing & Selling Margin</div>
                  <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', gap: 12 }}>
                    <div style={styles.formGroup}><label style={styles.label}>Cost Price (Rs)</label><input type="number" inputMode="decimal" step="0.01" value={quickMedForm.purchasePricePerUnit} onChange={e => setQuickMedForm({ ...quickMedForm, purchasePricePerUnit: e.target.value })} placeholder="0.00" style={styles.input} /></div>
                    <div style={styles.formGroup}><label style={styles.label}>Selling Price (Rs)</label><input type="number" inputMode="decimal" step="0.01" value={quickMedForm.sellingPricePerUnit} onChange={e => setQuickMedForm({ ...quickMedForm, sellingPricePerUnit: e.target.value })} placeholder="0.00" style={styles.input} /></div>
                    <div style={styles.formGroup}><label style={styles.label}>MRP (Rs)</label><input type="number" inputMode="decimal" step="0.01" value={quickMedForm.mrpPerUnit} onChange={e => setQuickMedForm({ ...quickMedForm, mrpPerUnit: e.target.value })} placeholder="0.00" style={styles.input} /></div>
                  </div>
                </div>

                <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 12, padding: isMobile ? 12 : 16 }}>
                  <div style={styles.formGroup}><label style={styles.label}>📍 Rack / Shelf Location</label><input value={quickMedForm.rackNumber} onChange={e => setQuickMedForm({ ...quickMedForm, rackNumber: e.target.value })} placeholder="e.g. Rack B-3, Shelf 2" style={styles.input} /></div>
                </div>
              </div>

              <div style={{ ...styles.modalFooter, padding: isMobile ? '16px' : '16px 20px' }}>
                <button type="button" onClick={() => setShowQuickAddMedModal(false)} style={{ ...styles.btnSecondary, background: '#fef5f5', color: '#991b1b', borderColor: '#fecaca' }}>Cancel</button>
                <button type="submit" style={{ ...styles.btnPrimary, background: 'linear-gradient(135deg, #1880c2 0%, #0369a1 100%)', boxShadow: '0 4px 12px rgba(24, 128, 194, 0.25)', padding: isMobile ? '12px 16px' : '10px 24px', fontSize: isMobile ? 14 : 14, fontWeight: 700 }}>✨ Save & Include in Purchase</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showMedDetailsModal && selectedMedDetails && (
        <MedicineDetailModal medicine={selectedMedDetails} onClose={() => { setShowMedDetailsModal(false); setSelectedMedDetails(null); }} isMobile={isMobile} fmt={fmt} />
      )}

      {showPurchaseDetailsModal && selectedPurchase && (
        <PurchaseDetailsModal purchase={selectedPurchase} onClose={() => { setShowPurchaseDetailsModal(false); setSelectedPurchase(null); }} isMobile={isMobile} fmt={fmt} />
      )}
    </div>
  );
}